export default {
  map: null,
  spacialMath: false,
  clustering: false,
  pinsData: [
    { layer: 'armazens', url: '/tracking/armazens/listarArmazens' },
    { layer: 'clientes', url: '/tracking/plantas/listarPlantas' },
    { layer: 'portos', url: '/tracking/portos/listarPortos' },
    { layer: 'rodoviarios', url: '/skymark/viagens' },
    { layer: 'rodoviariosB', url: '/skymark/viagens-esl' },
    { layer: 'maritimo', url: '/tracking/viagens' },
  ],
  mapsAPI: {},
  mapOptions: {
    enableClickableLogo: false,
    liteMode: true,
    customMapStyle: null,
    showMapTypeSelector: false,
    showLocateMeButton: false,
    showZoomButtons: true,
    showCopyright: false,
  },
  zoomInicial: 3,
};
